import axios from 'axios';
import Constants from '../constants';
import { IPersonAttribute } from '../models';

export async function getPersonAttributes(surveyId: number, audienceId: number, clientId: number): Promise<IPersonAttribute[]> {
	try {
		const url =
			Constants.AUDIENCE_API_BASE_URL.replace('{surveyId}', surveyId.toString()).replace('{audienceId}', audienceId.toString()) +
			Constants.AUDIENCE_DISTRIBUTION_ATTRIBUTES_API_URL +
			clientId;

		const res = await axios.get(url);
		if (res.status === 200) {
			return res.data;
		}
	} catch (Error) {
		//
	}
	throw Error('An error occurred trying to fetch person attributes');
}
